export default "__VITE_ASSET__569495e7__"